import type { TransitionConfig, EasingFunction } from 'svelte/transition';
import { linear, cubicOut } from 'svelte/easing';

export interface FadeParams {
  delay?: number;
  duration?: number;
  easing?: EasingFunction;
}

export function fade(
  node: HTMLElement,
  { delay = 0, duration = 400, easing = linear }: FadeParams = {},
): TransitionConfig {
  const o = +getComputedStyle(node).opacity;

  return {
    delay,
    duration,
    easing,
    tick: (t) => node.style.setProperty('opacity', String(t * o)),
  };
}

export interface FlyParams {
  delay?: number;
  duration?: number;
  easing?: EasingFunction;
  x?: number;
  y?: number;
  opacity?: number;
}

export function fly(
  node: HTMLElement,
  { delay = 0, duration = 400, easing = cubicOut, x = 0, y = 0, opacity = 0 }: FlyParams = {},
): TransitionConfig {
  const style = getComputedStyle(node);
  const target_opacity = +style.opacity;
  const transform = style.transform === 'none' ? '' : style.transform;

  const od = target_opacity * (1 - opacity);

  return {
    delay,
    duration,
    easing,
    tick: (t, u) => {
      node.style.setProperty(
        'transform',
        `${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px`,
      );
      node.style.setProperty('opacity', String(target_opacity - od * u));
    },
  };
}
